import axios from "axios";
import { API_BASE_PREFERENCE_MANAGEMENT } from "constants/index";
import store from "store";
import http from "./HttpService";

const objectToPayload = (obj: any) => {
  const payload = new FormData();
  Object.keys(obj).forEach((key) => {
    payload.append(key, obj[key]);
  });
  return payload;
};
const addPreferenceManagementPayload = (payload: FormData) => {
  const preferenceState = store.getState().preferenceManagement;
  if (preferenceState.id) {
    payload.append("unsub_uuid", preferenceState.id);
  }
  if (preferenceState.unsub_all) {
    payload.append("unsub_all", preferenceState.unsub_all);
  }
  if (preferenceState.marketing) {
    payload.append("marketing", preferenceState.marketing);
  }
  if (preferenceState.alerts) {
    payload.append("alerts", JSON.stringify(preferenceState.alerts));
  }
  if (preferenceState.news_letters) {
    const ids = preferenceState.news_letters
      .filter((newsLetter: any) => newsLetter.status === "1")
      .map((newsLetter: any) => newsLetter.id.toString())
      .join(",");
    if (ids.trim() !== "") {
      payload.append("news_letters_subscribed", ids);
    }
  }
  if (preferenceState.webinars) {
    payload.append("webinars", preferenceState.webinars);
  }
};

let cancelTokenGetPreferencesService: any;

export const getPreferencesService = async (unsubUuid: any) => {
  const payload = new FormData();
  payload.append("unsub_uuid", unsubUuid);

  //Check if there are any previous pending requests
  if (typeof cancelTokenGetPreferencesService != typeof undefined) {
    cancelTokenGetPreferencesService &&
      cancelTokenGetPreferencesService.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGetPreferencesService = axios.CancelToken.source();
  return await http.post(
    `${API_BASE_PREFERENCE_MANAGEMENT}get_recipient_details/`,
    payload,
    { cancelToken: cancelTokenGetPreferencesService.token } //Pass the cancel token to the current request
  );
};

let cancelTokenSubmitPreferencesService: any;

export const submitPreferencesService = async () => {
  const payload = new FormData();
  addPreferenceManagementPayload(payload);

  //Check if there are any previous pending requests
  if (typeof cancelTokenSubmitPreferencesService != typeof undefined) {
    cancelTokenSubmitPreferencesService &&
      cancelTokenSubmitPreferencesService.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenSubmitPreferencesService = axios.CancelToken.source();
  return await http.post(
    `${API_BASE_PREFERENCE_MANAGEMENT}update_preference/`,
    payload,
    { cancelToken: cancelTokenSubmitPreferencesService.token } //Pass the cancel token to the current request
  );
};

let cancelTokenSubmitPreferencesI2cService: any;

export const submitPreferencesI2cService = async (params:{[key:string]:string}) => {
  // const payload = {...params};
  const payload = new FormData();
  payload.append('unsub_uuid', params['unsub_uuid']);
  payload.append('unsub_flag', params['unsub_flag']);

  //Check if there are any previous pending requests
  if (typeof cancelTokenSubmitPreferencesI2cService != typeof undefined) {
    cancelTokenSubmitPreferencesI2cService &&
    cancelTokenSubmitPreferencesI2cService.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenSubmitPreferencesI2cService = axios.CancelToken.source();
  return await http.post(
    `${API_BASE_PREFERENCE_MANAGEMENT}update_preference/`,
    payload,
    { cancelToken: cancelTokenSubmitPreferencesI2cService.token } //Pass the cancel token to the current request
  );
};


export const logPreferenceEventService = async (params: any) => {
  return await http.post(`${API_BASE_PREFERENCE_MANAGEMENT}unsubscribe_page_events/`, objectToPayload(params));
};
